/**
 * formatEditedAgo — plain-English "X ago" for admin Voyage Plans list.
 *
 * Per CODING-BRIEF-A2.md §9 (B14 LOCKED) + CORRECTION 6.
 *
 * Uses Math.floor (NOT Math.round) so 90s reads as "1 minute ago"
 * (rounded DOWN — i.e. what just happened), NOT "2 minutes ago".
 *
 * Ladder:
 *   null / non-finite          → "Just now"
 *   < 60s                      → "Just now"
 *   60-3599s (1-59 min)        → "1 minute ago" / "N minutes ago"
 *   1-23h                      → "1 hour ago" / "N hours ago"
 *   ~24-47h (1 day)            → "Yesterday"
 *   2-6 days                   → "N days ago"
 *   >= 7 days                  → "Edited N days ago"
 *
 * Absolute timestamps only (UTC ms via Date.parse). No timezone math —
 * vessel timezone (FT-269) is irrelevant for relative display.
 *
 * @param {string|null|undefined} iso
 * @returns {string}
 */
export default function formatEditedAgo(iso) {
  if (!iso) return 'Just now';
  const then = new Date(iso).getTime();
  if (!Number.isFinite(then)) return 'Just now';
  const diff = Date.now() - then;
  if (diff < 60_000) return 'Just now';
  if (diff < 3_600_000) {
    const m = Math.floor(diff / 60_000);
    return `${m} minute${m === 1 ? '' : 's'} ago`;
  }
  if (diff < 86_400_000) {
    const h = Math.floor(diff / 3_600_000);
    return `${h} hour${h === 1 ? '' : 's'} ago`;
  }
  const d = Math.floor(diff / 86_400_000);
  if (d === 1) return 'Yesterday';
  if (d < 7) return `${d} days ago`;
  return `Edited ${d} days ago`;
}
